export default __webpack_public_path__ + "bcc98287f97c1e4014e1c7b83e28531a.png";